/** Structured address returned by the GraphQL `Address` type. */
export interface Address {
  id: string;
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
}

/** Single-line address string; empty when nothing is set. */
export function formatAddress(address?: Address | null): string {
  if (!address) return '';
  return [
    address.line1,
    address.line2,
    address.city,
    address.state,
    address.postalCode,
    address.country,
  ]
    .map((part) => (part || '').trim())
    .filter(Boolean)
    .join(', ');
}
